/** What a trade card can show. Panels sit alongside the stat strip's figures. */
export const CARD_PARTS = [
  { key: "avg_entry", label: "Avg Buying Price" },
  { key: "avg_exit", label: "Avg Selling Price" },
  { key: "qty", label: "Qty" },
  { key: "holding_days", label: "Days Held" },
  { key: "pnl", label: "P/L" },
  { key: "portfolio_pnl", label: "Portfolio P/L" },
  { key: "rr", label: "RR Ratio" },
  { key: "risk", label: "Risk ₹ | %" },
  { key: "journal_fields", label: "Stop, strategy, tags" },
  { key: "excursion", label: "MAE / MFE panel" },
  { key: "charts", label: "Charts" },
] as const;
